import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import API from 'core/Api';
import { ISelectOptionProps } from 'components/form/types';
import IResponseData from 'types/api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { IDropdowns } from '../types';
import CreateForm from './CreateForm';

export interface IProps {
  templatesEntityName: string;
  templatesDropdownsEntityName: string;
  templatesDropdownsEntityEndpoint: string;
}

const Create: FC<IProps> = ({
  templatesEntityName,
  templatesDropdownsEntityName,
  templatesDropdownsEntityEndpoint,
}) => {
  const { client } = useActiveClientContext();
  const {
    isLoading: isLoadingDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>(
    [buildClientEntity(templatesDropdownsEntityName, client)],
    (): Promise<IDropdowns> => {
      return API.get(templatesDropdownsEntityEndpoint).then(
        res =>
          res.data?.bg && {
            can_be_created_by: [
              {
                label: 'Работодател',
                value: 'only_employer',
              },
              {
                label: 'Работодател и служител',
                value: 'employer_and_employee',
              },
            ],
            employer_scenario: [
              {
                label: 'Сценарий 1',
                value: 'I-1',
              },
              {
                label: 'Сценарий 2',
                value: 'I-2',
              },
              {
                label: 'Сценарий 3',
                value: 'I-3',
              },
              {
                label: 'Сценарий 4',
                value: 'I-4',
              },
            ],
            employee_scenario: [
              {
                label: 'Сценарий 1',
                value: 'II-1',
              },
              {
                label: 'Сценарий 2',
                value: 'II-2',
              },
            ],
            // Spread the data last to override above values
            // once they are added to BE without breaking anything
            ...res.data.bg,
          }
      );
    }
  );
  const {
    isLoading: isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery<ISelectOptionProps[], Error>(
    [buildClientEntity('categories', client)],
    (): Promise<ISelectOptionProps[]> => {
      return API.get<IResponseData<{ id: number; name: string }>>('categories').then(res =>
        res.data?.items.map(cat => ({
          label: `${cat.id}. ${cat.name}`,
          value: cat.id.toString(),
        }))
      );
    }
  );

  return (
    <MainLayout
      title="Добавяне на шаблон за документ"
      isLoading={isLoadingDropdowns || isLoadingCategories}
      error={errorDropdowns || errorCategories}
    >
      {dropdowns && categories && (
        <CreateForm
          templatesEntityName={templatesEntityName}
          templateDataOptions={dropdowns}
          categories={categories}
        />
      )}
    </MainLayout>
  );
};

export default Create;
